import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Form, Button, FormGroup } from 'reactstrap';
import BusinessInputGroup from '../../../../common/forms/BusinessInputGroup';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';
import FormItem from '../../../../common/forms/FormItem';
import Select from '../../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../../utils/enum';
import { CREDIT_NOTE_MOTIVES_TICKET } from '../../../../../config/constants';
import TextInput from '../../../../common/forms/input/TextInput';

const selector = formValueSelector('VoucherTypeChangeForm');

const VoucherTypeChangeForm = ({
  handleSubmit,
  onCancel,
  creditNoteMotiveValue,
}) => (
  <>
    <Form onSubmit={handleSubmit}>
      <BusinessInputGroup
        label="Empresa"
        name="business"
        labelRequired
        form="VoucherTypeChangeForm"
        validate={[isRequired]}
      />
      <FormGroup row>
        <FormItem label="Motivo de Generación" required>
          <Field
            name="creditNoteMotive"
            component={Select}
            options={enumToSelectOptions(CREDIT_NOTE_MOTIVES_TICKET)}
            placeholder="Motivo de Generación"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {creditNoteMotiveValue &&
        creditNoteMotiveValue.value ===
          CREDIT_NOTE_MOTIVES_TICKET.OTHERS.value && (
          <FormGroup row>
            <FormItem label="Observación de Generación" required>
              <Field
                name="creditNoteMotiveDescription"
                component={TextInput}
                type="textarea"
                placeholder="Observación de Generación"
                validate={[isRequired]}
              />
            </FormItem>
          </FormGroup>
        )}
      <FormFooter saveButtonColor="secondary" saveButtonIcon={null}>
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  </>
);

VoucherTypeChangeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  creditNoteMotiveValue: PropTypes.instanceOf(Object),
};

VoucherTypeChangeForm.defaultProps = {
  creditNoteMotiveValue: null,
};

const mapStateToProps = (state) => ({
  creditNoteMotiveValue: selector(state, 'creditNoteMotive'),
});

const formComponent = reduxForm({
  form: 'VoucherTypeChangeForm',
})(VoucherTypeChangeForm);

export default connect(mapStateToProps, null)(formComponent);
